import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { MatTableDataSource } from '@angular/material/table';
import { forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Case } from 'src/app/models/case';
import { RequestTypeQualification } from 'src/app/models/requesttypequalification';
import { QualificationService } from 'src/app/services/qualifications.service';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { Settings } from 'src/app/services/settings';


@Component({
	selector: 'app-requesttype-masterqualify-mapping',
	templateUrl: './requesttype-masterqualify-mapping.component.html',
	styleUrls: ['./requesttype-masterqualify-mapping.component.css']
})
export class RequesttypeMasterqualifyMappingComponent implements OnInit {

	public selectedRecord: Case;
	public isEditing: boolean = false;
	public busyCursor = false;
	public topCheck: boolean = false;

	public contentClassWithBanner: string | null = 'qualify-mapping-with-banner';
	public contentClassWithoutBanner: string | null = 'qualify-mapping-without-banner';
	public contentClassName: string | null = 'qualify-mapping-without-banner';

	public tableClassWithBanner: string | null = 'table-container-with-banner';
	public tableClassWithoutBanner: string | null = 'table-container-without-banner';
	public tableClassName: string | null = 'table-container-without-banner';

	public strErr: string = '';
	public masterQualificationId: number = 0;

	public dataSource: MatTableDataSource<any>;
	records: any;
	public Idx: number | null = -1;
	public displayedColumns: string[] = ['selected', 'description', 'enable_auto_match', 'required'];
	public requestTypeQualificationsList: RequestTypeQualification[] = [];

	public modifyEnabled: boolean = false;

	@Output() editEvent = new EventEmitter<any>();

	constructor(public serviceRequestsService: ServiceRequestsService, private qualificationsService: QualificationService) {

	}

	ngOnInit() {
		if(Settings.getInstance().hasPrivilege("SETTINGS_MASTER_QUALIFICATION_REQUEST_TYPES", "WRITE")) {
			this.modifyEnabled = true;
		}
	}
	public onShowHandler(masterQualificationId: number): void {
		this.masterQualificationId = masterQualificationId;
		this.queryRecords();
	}
	public queryRecords() {

		if (Settings.getInstance().enableMessageBanner) {
			this.contentClassName = this.contentClassWithBanner;
			this.tableClassName = this.tableClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
			this.tableClassName = this.tableClassWithoutBanner;
		}

		this.busyCursor = true;

		this.qualificationsService.getAllRequestTypeQualificationsByMasterQualificationId(this.masterQualificationId).subscribe(
			(result) => {
				this.requestTypeQualificationsList = result;
				let selected = 0;

				this.serviceRequestsService.getAllServiceRequestTypes().subscribe(
					(result1) => {
						this.busyCursor = false;
						this.records = [];

						result1.sort((a, b) => {
							const nameA = a.description.toUpperCase(); // ignore upper and lowercase
							const nameB = b.description.toUpperCase(); // ignore upper and lowercase
							if (nameA < nameB) {
								return -1;
							}
							if (nameA > nameB) {
								return 1;
							}
							// names must be equal
							return 0;
						});

						for (const record of result1) {
							if(record.activeStatus !== 'Active') {
								continue;
							}
							const qualification = this.requestTypeQualificationsList.find(q => record.id === q.serviceRequestTypeId);

							if (qualification) {
								selected++;
								record['selected'] = true;
								record['required'] = !!qualification.required;  // Convert to boolean
								record['useForAutomatch'] = !!qualification.useForAutomatch;  // Convert to boolean
							} else {
								record['required'] = false;
								record['useForAutomatch'] = false;
								record['selected'] = false;
							}
							this.records.push(record);
						}

						this.dataSource = new MatTableDataSource(this.records);
						if(selected === this.records.length) {
							this.topCheck = true;
						}
						else {
							this.topCheck = false;
						}
					},
					(error1) => {
						Settings.getInstance().handleError(error1, 'Error: unable to retrieve request types data from the' +
							' service');
						this.busyCursor = false;
					}
				);
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Error: unable to retrieve request types data from the' +
					' service');
				this.busyCursor = false;
			}
		);
	}
	public toggleAllSelected(event:any): void {
		if (this.dataSource === undefined) {
			return;
		}

		for (const item of this.dataSource.filteredData) {
			item.selected = event.checked;
		}

	}
	public modifyHandler(): void {
		this.isEditing = true;

	}
	public cancelClickedEvent(): void {
		this.isEditing = false;
		this.editEvent.emit(this.isEditing);
		this.queryRecords();
	}
	public onRowClicked(row: any) {

	}
	public saveClickedEvent() {
		const deleteRequest = this.qualificationsService.deleteAllRequestTypeQualificationsByMasterQualificationId(this.masterQualificationId);

		deleteRequest.pipe(
			switchMap(() => {
				const createRequests = [];

				for (const record of this.records) {
					let mapping: RequestTypeQualification = new RequestTypeQualification();
					mapping.id = 0;
					mapping.masterQualificationId = this.masterQualificationId;
					mapping.serviceRequestTypeId = record.id;
					mapping.useForAutomatch = record['useForAutomatch'] ? 1 : 0; // Convert to 0 or 1
					mapping.required = record['required'] ? 1 : 0; // Convert to 0 or 1

					if (record['selected']===true) {
						createRequests.push(this.qualificationsService.createRequestTypeQualification(mapping));
					}
				}
				this.isEditing = false;
				return forkJoin(createRequests);
			})
		).subscribe(
			() => {
				this.isEditing = false;
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Error: unable to update date');
				this.busyCursor = false;
			}
		);
	}
	public onCheckboxChange(event: any, element: any) {
		if (element.useForAutomatch) {
			element.required = true;
		}
	}

}


